import { BRAND } from "../../constants/brand";
// BlogDetailPage.jsx
import React from "react";
import { Row, Col } from "antd";
import bannerImage3 from "../../assets/incubationBg.png";
import MainLayout from "../../components/layout/main-layout";
import styles from "./index.module.scss";
import { ShareArticleButtons } from "../../components/common/share-article-buttons";

const Imprintmindful = () => {
  const title = "{BRAND.domainLabel} introduces a mindful option to social media at the Conduit Club in London drawing support from its members"

  return (
    <MainLayout>
      <div className={styles.blogDetailPage}>
        {/* Hero Banner */}
        <div
          className={styles.banner}
          style={{
            background: `url(${bannerImage3}) no-repeat center center/cover`,
          }}
        >
          <h1>
            {title}
          </h1>
        </div>

        {/* Author & Content Layout */}
        <Row gutter={[32, 32]} className={styles.mainContent}>
          {/* Sidebar */}
          <Col xs={24} md={7}>
            <div className={styles.sidebar}>
              <div className={styles.authorBox}>
                <div className={styles.authorInfo}>
                  <h3>Press Releases</h3>
                </div>
              </div>
              <div className={styles.postHeader}>
                <div className={styles.topBorder} />
                <p className={styles.publishDate}>
                  Published on November, 2024
                </p>
                <h1 className={styles.postTitle}>
                  {title}
                </h1>
              </div>

              <ShareArticleButtons title />

            </div>
          </Col>

          {/* Blog Content */}
          <Col xs={24} md={17}>
            <div className={styles.articleWrapper}>
              <p>
                On 3 December, {BRAND.domainLabel} hosted a private event at the
                Conduit Club in London to introduce its new social media
                platform to club members.
              </p>

              <p>
                The afternoon event offered attendees a unique opportunity to
                engage directly with the platform's founders, gain insight into
                the vision behind {BRAND.domainLabel}, and experience a live
                demonstration of its key features. Members were encouraged to
                ask questions, share feedback, and explore the product
                firsthand.
              </p>

              <p>
                Co-founders, Andrew and Harleen Ahluwalia-Cook, shared
                {BRAND.domainLabel}'s development journey, challenges they have
                navigated, and the meaningful impact they hope the platform will
                achieve.
              </p>

              <p>
                The event highlighted the innovation driving {BRAND.domainLabel} and
                helped to strengthen its growing community of early supporters.
                It marked a significant step forward as the platform moves
                closer to its broader launch.
              </p>
            </div>
          </Col>
        </Row>
      </div>
    </MainLayout>
  );
};

export default Imprintmindful;
